import { Alert } from '@change/ds-core-ui/Alert';
import { Text } from '@change/ds-core-ui/Text';
import { cn } from '@change/ds-utils';

import { translationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core-react/i18n';

import { StepActions } from '#src/app/pages/startAPetitionV2/shared/components';
import { ImageCropperUploader } from '#src/app/shared/components/imageUpload';
import { useIsMobile } from '#src/app/shared/hooks/userAgent';

import { useUploaderCropperForm } from './hooks/useUploaderCropperForm';

export const UploaderCropperForm = () => {
	const { data, actions } = useUploaderCropperForm();
	const isMobile = useIsMobile();
	const isCompactMobileUploader = isMobile && !data.image;

	return (
		<>
			<div
				className={cn([
					// These classes are used to hide the "drop target" area (dashed box) on mobile/tablet devices
					isCompactMobileUploader
						? '[&_#sap-media-view]:mb-0! [&_#sap-media-view]:w-full! [&_#sap-media-view_label]:w-full! [&>div>div]:border-0! [&>div>div>div>div:first-child]:hidden!'
						: '[&_#sap-media-view]:mb-0! md:[&_#sap-media-view]:mb-16!',
				])}
			>
				<ImageCropperUploader
					uploader={data.uploader}
					image={data.image}
					onButtonClick={actions.handleUploadClick}
					onImageChange={actions.handleImageChange}
					onImageCrop={actions.handleImageCrop}
					onCancelClick={actions.handleCancelUpload}
					uploaderContainerClassName={isCompactMobileUploader ? 'h-auto' : 'h-[272px]'}
				/>
				{data.imageError && (
					<Alert type="inline" variant="warning" className="mt-4">
						<Text as="p" variant="body">
							<TypedTranslate value={data.imageError} />
						</Text>
					</Alert>
				)}
				{data.uploadError && (
					<Alert type="inline" variant="error" className="mt-4">
						<Text as="p" variant="body">
							<TypedTranslate value={data.uploadError} />
						</Text>
					</Alert>
				)}
			</div>
			<StepActions
				type="navigation"
				onPrimaryAction={actions.submit}
				onSecondaryAction={actions.back}
				submitting={data.isUploading}
				submittingLabel={translationKey('corgi.start_a_petition.media.step_actions.button.uploading_label')}
			/>
		</>
	);
};
